import * as contractStatuses from 'constants/enums/contractStatuses'

export default {
  [contractStatuses.NEW]: 'Nová',
  [contractStatuses.PENDING_SIGNATURE]: 'Čeká na podpis',
  [contractStatuses.REALIZED]: 'Realizována',
  [contractStatuses.NOT_REALIZED]: 'Nerealizována',
}
